module.exports = __webpack_public_path__ + "media/components/riskregister/icons/pin-49a9eafaae0969eed3fc4bc8258582e5.png";